import { render } from "./FAQView.vue?vue&type=template&id=213cc7b4&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=213cc7b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-213cc7b4"

export default script